import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Search } from 'semantic-ui-react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

const SidebarSearch = (props) => {
    const { t } = useTranslation()
    const {
        results = [],      // Array de resultados a mostrar visualmente
        value = '',        // Texto del input
        loading = false,   // Spinner de carga
        placeholder = t('Buscar...'),
        inputStyle = {},
        className = '',
        size = 'large',    // 'small', 'mini', 'large', 'big', 'huge', 'massive'

        // Eventos básicos para interactuar
        onSearchChange,
        onSelectOption,

        // Control visual: ¿Se debe mostrar la lista desplegable?
        open = false
    } = props

    // Referencias para el "truco" visual del Portal
    const wrapperRef = useRef(null)
    const mainRef = useRef(null)

    // Estado exclusivamente para coordenadas visuales (top, left, width)
    const [portalPos, setPortalPos] = useState({ top: 0, left: 0, width: 0 })

    // --- LÓGICA VISUAL: POSICIONAMIENTO DEL MENÚ (PORTAL) ---
    // Esto asegura que la lista flote exactamente debajo del input
    const updatePortalPos = () => {
        const el = wrapperRef.current
        if (!el) return
        const r = el.getBoundingClientRect()
        setPortalPos({
            top: r.bottom,
            left: r.left,
            width: r.width,
        })
    }

    // Actualizar posición al hacer scroll o resize para que no se desencaje
    useEffect(() => {
        if (!open) return
        updatePortalPos()
        window.addEventListener('scroll', updatePortalPos, true)
        window.addEventListener('resize', updatePortalPos)
        return () => {
            window.removeEventListener('scroll', updatePortalPos, true)
            window.removeEventListener('resize', updatePortalPos)
        }
    }, [open, value])

    // Mezcla de estilos para que el input se vea igual
    const defaultInputStyle = {
        height: 40,
        fontSize: 16,
        ...inputStyle,
    }

    return (
        <div ref={wrapperRef} className={className} style={{ position: 'relative' }}>
            {/* 1. El Input de Semantic UI */}
                <Search
                    open={false} // Siempre false aquí porque renderizamos la lista manualmente abajo
                    loading={loading}
                    size={size}
                    input={{
                        ref: mainRef,
                    placeholder: placeholder,
                    style: defaultInputStyle,
                }}
                onSearchChange={onSearchChange}
                value={value}
                onFocus={() => {
                    // Recalcula posición visual al enfocar
                    setTimeout(updatePortalPos, 0)
                }}
            />

            {/* 2. La Lista de Resultados (Renderizada en el body vía Portal) */}
            {open && results.length > 0 && ReactDOM.createPortal(
                <div
                    style={{
                        position: 'fixed',
                        top: portalPos.top,
                        left: portalPos.left,
                        width: portalPos.width,
                        zIndex: 999999, // Z-index alto para sobreponerse a todo
                    }}
                >
                    {/* Estructura de clases EXACTA de Semantic UI */}
                    <div className="ui fluid search active">
                        <div className="results transition visible" style={{ display: 'block' }}>
                            {results.map((r, index) => (
                                <a
                                    key={r.id || index}
                                    className="result"
                                    // preventDefault en onMouseDown es vital para que el click funcione antes del blur
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => onSelectOption && onSelectOption(r)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="content">
                                        <div className="title">{r.title}</div>
                                        {r.description && (
                                            <div className="description">{r.description}</div>
                                        )}
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    )
}

SidebarSearch.propTypes = {
    results: PropTypes.array,
    value: PropTypes.string,
    loading: PropTypes.bool,
    placeholder: PropTypes.string,
    inputStyle: PropTypes.object,
    className: PropTypes.string,
    size: PropTypes.string,
    onSearchChange: PropTypes.func,
    onSelectOption: PropTypes.func,
    open: PropTypes.bool
}

export default SidebarSearch
